import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreateCompanyUserPayload, Plant } from '@/interfaces';

import CompanyUserForm from '../forms/CompanyUserForm';

import useUserForm from '../../hooks/utils/useUserForm';

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  companyPlants: Plant[];
  handleCreateUser: (payload: CreateCompanyUserPayload) => Promise<void> | void;
  companyId: number;
};

export default function CreateCompanyUsersModal({ setIsOpen, companyPlants, handleCreateUser, companyId }: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, updatePlants, handleSubmit, updateRole } = useUserForm({
    onSubmit: async (payload) => {
      await handleCreateUser(payload);
      setIsOpen(false);
    },
    companyId,
  });

  return (
    <TradingModal
      titleText={t('settings.companyDetailsTab.companyUsers.modal.createUsersTitle')}
      bodyText={
        <CompanyUserForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          companyPlants={companyPlants}
          updateField={updateField}
          updateRole={updateRole}
          updatePlants={updatePlants}
          handleSubmit={handleSubmit}
          type="create"
        />
      }
      open
      onClose={() => setIsOpen(false)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
      shouldCloseOnBackdropClick={false}
    />
  );
}
